import React, { useEffect } from 'react';
import { API_KEY_CREATION } from '@he-novation/config/paths/modals.constants';
import { asyncApiKeyList } from '@he-novation/front-shared/async/api-key.async';
import { useAtom, useAtomValue } from 'jotai';

import { workspaceApiKeysAtom, workspaceNameAtom } from '$atoms/workspace-atoms';
import { DataLayoutApiKeys } from '$components/DataLayout/DataLayoutApiKeys/DataLayoutApiKeys';
import { useSearchState } from '$components/HOC/withSearchState';
import { SubHeader } from '$components/layout/Header/SubHeader/SubHeader';
import { useDataLayout } from '$hooks/useDataLayout';
import { useModal } from '$hooks/useModal';
import { useTranslate } from '$hooks/useTranslate';
import { useWorkspaceAdminMembers } from '$hooks/useWorkspaceMembers';

export function SettingsWorkspaceApiKeys() {
    const { t } = useTranslate();
    const { openModal } = useModal();

    const workspaceName = useAtomValue(workspaceNameAtom);
    const { workspaceAdminMembers, fetchWorkspaceAdminMembers } = useWorkspaceAdminMembers();

    const [apiKeys, setApiKeys] = useAtom(workspaceApiKeysAtom);

    useEffect(() => {
        fetchWorkspaceAdminMembers(workspaceName);
        asyncApiKeyList(workspaceName).then(setApiKeys);
    }, []);

    const dataLayout = useDataLayout({
        layoutPrefsName: 'settings_workspace_api_keys',
        groupers: [],
        defaultSort: ['name', false]
    });
    const { search, setSearch, onSearchInput } = useSearchState();

    return (
        <>
            <SubHeader
                subClassName={'settings-sub-header'}
                title={t('settings.API keys')}
                groupers={[
                    {
                        grouper: dataLayout.grouper,
                        setGrouper: dataLayout.setGrouper,
                        groupers: dataLayout.groupers,
                        saveLayoutPrefs: dataLayout.saveLayoutPrefs
                    }
                ]}
                actions={[
                    {
                        children: t('settings.Create API key'),
                        onClick: () =>
                            openModal(API_KEY_CREATION, { workspaceMembers: workspaceAdminMembers })
                    }
                ]}
                search={{
                    search,
                    setSearch,
                    onSearchInput
                }}
            />
            <DataLayoutApiKeys items={apiKeys} dataLayout={dataLayout} search={search} />
        </>
    );
}
